import { FC } from "react";
import { cn } from "@/libs/utils";
import { MDViewer } from "../../common/MDViewer";
type Props = {
  className?: string;
  isError: boolean;
  md: any;
};

const RightSection: FC<Props> = ({ className = "", isError, md }) => {
  return (
    <div className={cn(className, "flex flex-col")}>
      <span className={"bg-gray_18 mt-[46px] hidden h-px w-full md:block"} />
      <MDViewer isError={isError} md={md} />
    </div>
  );
};

export default RightSection;
